<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="gacha-detail-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="gacha-view">
                        <vuescroll>
                            <div class="gacha-view__item" :class="item.type" v-for="(item,index) in gacha_config" :key="index">
                                <div class="gacha-view__slogen">概率{{ item.rate }}%</div>

                                <div class="item-list flex-center-center flex-wrap">
                                    <div class="item" v-for="(it,idx) in item.items" :key="idx">
                                        <div class="reward-wrapper" :class="it.rare" v-if="it.type == 'item'">
                                            <div class="reward-pic" v-tips="it.id"><game-item :locked="true" :id="it.id" :num="it.num"></game-item></div>
                                        </div>

                                        <div class="opt-item" v-else>
                                            <div class="rb-pic" :class="it.rare">
                                                <div class="rb-icon" :class="it.id"></div>
                                            </div>
                                        </div>

                                        <div class="opt-label" :class="item.type" v-if="it.or"></div> 

                                        <div class="game-item" v-if="it.or">
                                            <div class="reward-wrapper">
                                                <div class="reward-pic" v-tips="it.or"><game-item :locked="true" :id="it.or" :num="1"></game-item></div>
                                            </div>
                                            
                                            <div class="desc">{{ it.name }}</div>
                                        </div>                                
                                    </div>
                                </div>
                            </div>
                        </vuescroll>
                    </div>                  
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>

.gacha-detail-modal{
    width: 690px;
    height: 793px;
    background-image: url(~@/assets/images/modal/bg-modal-detail.png);  
}

.title{
    width: 586px;
    height: 49px;
    margin: 0 auto 20px;
    background-repeat : no-repeat;
    background-position : center;
    background-image: url(~@/assets/images/modal/title-gacha-detail.png);    
}

.gacha-view{
    height: 640px;
    padding: 0 20px;

    &__item{
        margin-bottom: 30px;

        &:last-child{
            margin-bottom: 0;
        }
    }

    &__slogen{
        width: 551px;
        height: 31px;
        line-height: 31px;
        margin: 0 auto 20px;
        background-image: url(~@/assets/images/modal/slogen-modal-detail.png);
        text-align: center; 
        color: #f2d47a;
        font-family: 'HYJinKaiJ';
    }

    .item-list{
        width: 640px;
        margin: 0 auto;
    }

    .item{
        margin: 0 10px 10px;
    }

    .ur .item{
        display: flex;
        align-items: center;
        // height: 148px;
    }

    .opt-item{
        text-align: center;
        font-size: 18px;
        color: #f8e1dc;

        b{
            font-weight: 400;
            color: #f2d47a;
        }

        .rb-icon{
            margin: 0 auto;
        }

        .ur .rb-icon.rb-10000{
            width: 93px;
            height: 90px;
            background-image: url(~@/assets/images/modal/rb/10000-ur.png);
        }

        .ur .rb-icon.rb-1000{
            width: 92px;
            height: 90px;
            background-image: url(~@/assets/images/modal/rb/1000-ur.png);
        }

    }

    .ur .opt-item{
        display: flex;
        align-items: center;
    }

    .opt-label{
        width: 47px;
        height: 21px;
        margin: 4px auto;
        background-image: url(~@/assets/images/modal/opt-label_2.png);

        &.ur{
            width: 25px;
            height: 77px;
            margin: 0 5px 0 17px;
            background-image: url(~@/assets/images/modal/opt-label_1.png);            
        }
    }

    .desc{
        margin-top: 5px;
        font-size: 18px;
        color: #ffd7c5;
    }
}

.reward-wrapper{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 82px;
    height: 82px;
    margin: 0 auto;
    background-image: url(~@/assets/images/modal/bg-item_d.png);

    .reward-pic{
        width: 68px;
        height: 68px;
    }

    &.ur{
        width: 92px;
        height: 92px;
        background-image: url(~@/assets/images/modal/bg-item_ur.png);

        .reward-pic{
            width: 68px;
            height: 68px;
        }

    }
}


</style>

<script>
export default {
    data () {
        return {
            visible : false,
            gacha_config : [
                {
                    type : 'ur',
                    rate : 0.5,
                    items : [
                        { id : 'QE36' , name : '匠心宝箱', type : 'item', num : 1 , rare : 'ur'},
                        { id : 'rb-10000' , name : '10000红包', type : 'currency', num : 1 , rare : 'ur'},
                        { id : 'rb-1000' , name : '1000红包', type : 'currency', num : 1 , rare : 'ur'},
                    ]
                },
                {
                    type : 'sr',
                    rate : 32,
                    items : [
                        { id : 'rb-100' , name : '100红包', type : 'currency', num : 1 , or : 'QE35', name : '匠心钻石宝箱' },
                        { id : 'rb-50' , name : '50红包', type : 'currency', num : 1 , or : 'QE34', name : '匠心铂金宝箱' },
                        { id : 'rb-20' , name : '20红包', type : 'currency', num : 1 , or : 'QE33', name : '匠心黄金宝箱' },
                        { id : 'rb-10' , name : '10红包', type : 'currency', num : 1 , or : 'QE32', name : '匠心白银宝箱' },
                        { id : 'rb-5' , name : '5红包', type : 'currency', num : 1 , or : 'QE31', name : '匠心青铜宝箱' },
                    ]
                },
                {
                    type : 'c',
                    rate : 67.5,
                    items : [
                        { id : 'PK19' , name : '神机玄灵武器珍材自选包(30天)', type : 'item', num : 5 },
                        { id : 'AQ32' , name : '神之武器打造书页', type : 'item', num : 5 },
                        { id : 'AQ33' , name : '神之武器打造书页', type : 'item', num : 5 },
                        { id : 'QA22' , name : '高级防具珍材包', type : 'item', num : 10 },
                        { id : 'OU60' , name : '混元五禽令/七宝琉璃灯自选包(30天)', type : 'item', num : 5 },
                        { id : 'NG58' , name : '七宝琉璃灯/空相宝莲自选包(30天)', type : 'item', num : 5 },
                        { id : 'X472' , name : '十万士兵卷轴(180天)', type : 'item', num : 10 },
                    ]
                }
            ],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>